import { render } from "./DeleteButtonRenderer.vue?vue&type=template&id=5061a0c1"
import script from "./DeleteButtonRenderer.vue?vue&type=script&lang=js"
export * from "./DeleteButtonRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__